<!--经销商部门管理-->
<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form :inline="true"
             :model="dataForm"
             @keyup.enter.native="queryDepartment()"
             @submit.native.prevent>
      <el-row>
        <el-col :span="7">
          <!--部门名称-->
          <el-form-item :label="$t('res.department.departmentName')">
            <el-input v-model.trim="dataForm.name" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item></el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item>
            <el-button class="M-search"
                       style="margin-bottom: 7px"
                       type="primary"
                       :loading="dataListLoading"
                       @click="queryDepartment">{{$t('user.query')}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="search">
      <!--新增部门-->
      <el-button type="primary" :loading="dataListLoading" @click="addOreditDepartment('add')">{{ $t('res.department.createDepartment') }}</el-button>
    </div>
    <br>
    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%;">
      <!--部门名称-->
      <el-table-column prop="name" header-align="center" align="center" show-overflow-tooltip :label="$t('res.department.departmentName')">
      </el-table-column>
      <!--部门英文名称-->
      <!--<el-table-column prop="nameEn" header-align="center" align="center" show-overflow-tooltip :label="$t('res.department.departmentEnName')">-->
      <!--</el-table-column>-->
      <!--部门代码-->
      <el-table-column prop="code" header-align="center" align="center" show-overflow-tooltip :label="$t('res.department.code')">
      </el-table-column>
      <el-table-column
        align="center"
        width="100"
        :label="$t('handle')">
        <template slot-scope="scope">
          <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
            <el-dropdown-menu slot="dropdown">
              <!--编辑-->
              <el-dropdown-item @click.native="addOreditDepartment('edit', scope.row)">{{ $t('res.vehinfo.edit') }}
              </el-dropdown-item>
              <!--删除-->
              <el-dropdown-item @click.native="deleteDepartment(scope.row)">{{ $t('delete') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="pageSizeChangeHandle"
                   @current-change="pageCurrentChangeHandle"
                   :current-page="page"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="limit"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="total">
    </el-pagination>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/talent/department/list',
        getDataListIsPage: true
      },
      dataForm: {
        name: ''
      },
      dataList: [],
      dataListLoading: false
    }
  },
  activated () {
    this.getDataList()
  },
  methods: {
    // 删除
    deleteDepartment (row) {
      this.$confirm(this.$t('res.department.deleteDep'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.dataListLoading = true
        let param = {
          'id': row.id
        }
        this.$request.post(
          `/talent/department/delete`, param
        ).then((res) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getDataList()
              this.dataListLoading = false
            }
          })
        }).catch(() => {
          this.dataListLoading = false
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 新建、编辑
    addOreditDepartment (type, row) {
      let query = {}
      if (row) {
        query.id = row.id
      }
      query.type = type
      let name = 'ochart-ochartdepartment-add-or-update'
      this.$router.push({
        name: name,
        query: query
      })
      // 广播通知执行初始化方法
      this.$eventHub.$emit(this.GLOBAL.OCHART_DEPARTMENT, '')
    },
    queryDepartment () {
      this.page = 1
      this.getDataList()
    }
  }
}
</script>
<style>

</style>
